import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingUnblurImageConfig } from '@/data/landingConfig/landingUnblurImageConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_UnblurImage } from './schemaObject';

interface Props {}
const UnblurImage: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_UnblurImage} />
			<LandingTemplate
				data={landingUnblurImageConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageEnhancementV2()}
			/>
		</>
	);
};

export default UnblurImage;
